/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateAttachmentDto
 */
export interface CreateUpdateAttachmentDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateAttachmentDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    examinedId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    examId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    testId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    visitRegistrationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    type?: string | null;
    /**
     * Zawartość pliku jako base64 string
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    file?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    storageKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentDto
     */
    objectId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateAttachmentDto interface.
 */
export function instanceOfCreateUpdateAttachmentDto(value: object): value is CreateUpdateAttachmentDto {
    return true;
}

export function CreateUpdateAttachmentDtoFromJSON(json: any): CreateUpdateAttachmentDto {
    return CreateUpdateAttachmentDtoFromJSONTyped(json, false);
}

export function CreateUpdateAttachmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAttachmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
        'examinedId': json['examinedId'] == null ? undefined : json['examinedId'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'testId': json['testId'] == null ? undefined : json['testId'],
        'visitRegistrationId': json['visitRegistrationId'] == null ? undefined : json['visitRegistrationId'],
        'type': json['type'] == null ? undefined : json['type'],
        'file': json['file'] == null ? undefined : json['file'],
        'storageKey': json['storageKey'] == null ? undefined : json['storageKey'],
        'objectId': json['objectId'] == null ? undefined : json['objectId'],
    };
}

export function CreateUpdateAttachmentDtoToJSON(value?: CreateUpdateAttachmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'description': value['description'],
        'name': value['name'],
        'examinedId': value['examinedId'],
        'examId': value['examId'],
        'testId': value['testId'],
        'visitRegistrationId': value['visitRegistrationId'],
        'type': value['type'],
        'file': value['file'],
        'storageKey': value['storageKey'],
        'objectId': value['objectId'],
    };
}

